<template>
  <div>
    <v-video
      v-if="researchItem.item.is_video"
      :youtube-id="researchItem.item.youtube_id"
    />

    <div
      v-if="researchItem.item.is_audio"
      class="p-4"
    >
      <v-audio
        :source="researchItem.item.media_file"
      />
    </div>

    <v-image
      v-if="researchItem.item.is_image"
      :source="researchItem.item.media_file"
    />
  </div>
</template>

<script>
import Video from '@/common/components/Video.vue';
import Audio from '@/common/components/Audio.vue';
import Image from '@/common/components/Image.vue';

export default {
  name: 'ItemMedia',
  components: {
    'v-video': Video,
    'v-audio': Audio,
    'v-image': Image,
  },
  props: {
    researchItem: {
      type: Object,
      required: true,
    },
  },
};
</script>
